<template>
  <router-view />
</template>

<script>
export default {
  name: 'CarManagementCarsIndex'
}
</script>
